<template>
  <div>
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #end>
          <Button label="Nuevo" icon="pi pi-plus" class="p-button-success mr-2" @click="agregarEmpleado" />
        </template>
      </Toolbar>
    </div>
    <DataTable :value="lstEmpleados" dataKey="Matricula" scrollDirection="both" :filters="filters" :scrollable="true"
      scrollHeight="60vh" :paginator="false" :rows="100" :loading="loading"
      :globalFilterFields="['NombreCompleto', 'Matricula', 'Puesto', 'Categoria','Turno','Horario','Correo_inst','Tipo_contratacion','Nombre_remedy','Fecha_nacimiento']">
      <template #header>
        <div class="table-header">
          <h5>EMPLEADOS</h5><br>
          <span>
            Número de empleados {{ lstEmpleados ? lstEmpleados.length : 0 }}
          </span>


          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" placeholder="Buscar..." />
          </span>
        </div>
      </template>
      <template #empty>
        No se encontrarón registros.
      </template>
      <template #loading>
        Cargando datos. Espere por favor
      </template>
      <Column style="width: 150px;">
        <template #body="slotProps">
          <Button icon="pi pi-pencil" severity="success" rounded size="large" aria-label="Editar"
            @click="editarEmpleado(slotProps.data)" />
          <Button icon="pi pi-user" class="p-button-rounded p-button-help ml-2 p-button-xl"
            aria-label="Detalles" @click="dialogDetalles(slotProps.data)" />
          <Button v-if="slotProps.data.Categoria == 'COORDINADOR DE SOPORTE TECNICO' || slotProps.data.Categoria == 'OFICIAL DE SOPORTE TECNICO'" style="margin-left: 5px;" icon="pi pi-sitemap" class="p-button-rounded p-button-info p-mr-4" @click="dialogChart(slotProps.data)" />
        </template>
      </Column>
      <Column field="Matricula" header="Matrícula" sortable style="width: 10%;"></Column>
      <Column field="Nombres" header="Nombres" sortable style="width: 25%">
        <Column field="Ap_pat" header="Apellido paterno" sortable style="width: 180px"></Column>
      <Column field="Ap_mat" header="Apellido materno" sortable style="width: 180px"></Column>
      <Column field="Turno" header="Turno" sortable style="width: 150px"></Column>
      <Column field="Dias_descanso" header="Dias de descanso" style="width: 180px"></Column>
        <template #body="slotProps">
          <div class="flex flex-column">
          <div>
            <b>{{ slotProps.data.Ap_pat }} {{ slotProps.data.Ap_mat }} {{ slotProps.data.Nombres }}</b>
          </div>
          <div v-if="slotProps.data.Correo_inst">
            ✉️  <!-- Símbolo de sobre para correo -->
            {{ slotProps.data.Correo_inst }}
          </div>       
          <div v-if="slotProps.data.Telefono">
            📞  <!-- Símbolo de teléfono -->
            {{ slotProps.data.Telefono }}
          </div>
          <div v-if="slotProps.data.Fecha_nacimiento">
            🎂  <!-- Símbolo de calendario -->
            {{ formateaFechaDDMMYY(slotProps.data.Fecha_nacimiento) }}
          </div>
        </div>
        </template>
      </Column>
      <Column field="Turno" header="Turno" sortable style="width: 15%">
        <template #body="{ data }">
          <div class="flex flex-column">
            <div>
              <b>{{ data.Turno }}</b>
            </div>
            <div>
              {{ data.Horario }}
            </div>
            <div>
              <b>Descanso:</b> 
            </div>
            <div>
              {{ getDiasLabels(data.Dias_descanso) }}
            </div>
        </div>
        </template>
      </Column>
      <Column field="Tipo_contratacion" header="Puesto" sortable style="width: 220px">
        <template #body="{ data }">
          <div class="flex flex-column">
            <div>{{ data.Puesto }}</div>
            <div> {{ data.Tipo_contratacion }} </div>
          </div>
        </template>
      </Column>
      <Column field="Id_estatus" header="Estatus" style="width: 120px">
        <template #body="{ data }">
          <span :class="getStatusClass(data.Id_estatus)">{{ getLabelStatus(data.Id_estatus) }}</span>
        </template>
      </Column>
      <!-- <Column field="Categoria" header="Categoría" sortable style="width: 120px"></Column> -->
      <template #footer>
        Registros en total {{ lstEmpleados ? lstEmpleados.length : 0 }}
      </template>
    </DataTable>
    <Dialog :style="{ width: '850px' }" :visible="showDetalles" :modal="true" :closable="false" class="p-fluid">
      <template #header>
        <h3>DETALLES: {{ NombreCompleto }}</h3>
      </template>
      <TabView @Tab-Change="llamarJerarquia">
        <div v-if="objEmpleado.Categoria === 'COORDINADOR DE SOPORTE TECNICO'">
          <TabPanel header="Unidades">
            <h3>El coordinador no puede ser asignado a unidades</h3>
          </TabPanel>
        </div>
        <div v-else-if="objEmpleado.Categoria === 'CONFIANZA'">
          <TabPanel header="Unidades">
            <h3>Confianza no puede ser asignado a unidades</h3>
          </TabPanel>
        </div>
        <div v-else>
          <TabPanel header="Unidades">
            <Toolbar>
              <template #end>
                <Button label="Asignar Unidades" icon="pi pi-plus" class="p-button-help mr-2" @click="asignarUnidades" />
              </template>
            </Toolbar>


            <div class="contenedor">
              <span class="titulo-unidad">Unidades asignadas</span>
            </div>
            <div v-for="unidad in unidades" :key="unidad.Id_unidad" class="unidad-item">
              <p class="nombre-unidad">{{ unidad.Nombre_unidad }}</p>
              <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2" aria-label="Eliminar"
                @click="eliminarUnidadAsignada(unidad.Matricula, unidad.Id_unidad)" />
            </div>
          </TabPanel>
        </div>


        <TabPanel header="Jerarquia">
          <Toolbar v-if="objEmpleado.Categoria !== 'AUXILIAR DE SOPORTE TECNICO'">
            <template #end>
              <Button label="Asignar Jerarquia" icon="pi pi-plus" class="p-button-help mr-2" @click="asignarJerarquia" />
            </template>
          </Toolbar>


          <div v-if="objEmpleado.Categoria === 'OFICIAL DE SOPORTE TECNICO'">
            <h3>Coordinador a cargo</h3>
            <DataTable :value="coordinadorACargo" dataKey="Id_empleado_jerarquia" :scrollable="true" scrollHeight="65vh"
              :paginator="false" :loading="loading">
              <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
              <Column field="Categoria_asociado" header="Categoria" sortable></Column>
              <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                <template #body="{ data }">
                  <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                </template>
              </Column>
            </DataTable>


            <h3>Auxiliares asignados</h3>
            <DataTable :value="auxiliaresAsignados" dataKey="Id_empleado_jerarquia" :scrollable="true" scrollHeight="65vh"
              :paginator="false" :loading="loading">
              <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
              <Column field="Categoria_asociado" header="Categoria" sortable></Column>
              <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                <template #body="{ data }">
                  <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                </template>
              </Column>
              <Column>
                <template #body="slotProps">
                  <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2" aria-label="Eliminar"
                    @click="eliminarJerarquia(slotProps.data.Id_empleado_jerarquia)" />
                </template>
              </Column>
            </DataTable>
          </div>


          <div v-else>
            <div v-if="objEmpleado.Categoria === 'AUXILIAR DE SOPORTE TECNICO'">
              <h3>Oficial a cargo</h3>
              <DataTable :value="jerarquia" dataKey="Id_empleado_jerarquia" :scrollable="true" scrollHeight="65vh"
                :paginator="false" :loading="loading">
                <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
                <Column field="Categoria_asociado" header="Categoria" sortable></Column>
                <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                  <template #body="{ data }">
                    <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                  </template>
                </Column>
              </DataTable>
            </div>
            <div v-if="objEmpleado.Categoria === 'CONFIANZA'">
              <h3>Empleados asignados</h3>
              <DataTable :value="empleadosAsignados" dataKey="Id_empleado_jerarquia" :scrollable="true"
                scrollHeight="65vh" :paginator="false" :loading="loading">
                <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
                <Column field="Categoria_asociado" header="Categoria" sortable></Column>
                <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                  <template #body="{ data }">
                    <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                  </template>
                </Column>
                <Column>
                  <template #body="slotProps">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2" aria-label="Eliminar"
                      @click="eliminarJerarquia(slotProps.data.Id_empleado_jerarquia)" />
                  </template>
                </Column>
              </DataTable>


              <h3>Jefe</h3>
              <DataTable :value="jefe" dataKey="Id_empleado_jerarquia" :scrollable="true" scrollHeight="65vh"
                :paginator="false" :loading="loading">
                <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
                <Column field="Categoria_asociado" header="Categoria" sortable></Column>
                <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                  <template #body="{ data }">
                    <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                  </template>
                </Column>
              </DataTable>
            </div>
            <div v-if="objEmpleado.Categoria === 'COORDINADOR DE SOPORTE TECNICO'">
              <h3>Oficial asignado </h3>


              <DataTable :value="jerarquia" dataKey="Id_empleado_jerarquia" :scrollable="true" scrollHeight="65vh"
                :paginator="false" :loading="loading">
                <Column field="Nombre_asociado" header="Nombre Asociado" sortable></Column>
                <Column field="Categoria_asociado" header="Categoria" sortable></Column>
                <Column field="Trabaja_directo" header="Trabaja Directo" sortable>
                  <template #body="{ data }">
                    <span>{{ getTrabaja(data.Trabaja_directo) }}</span>
                  </template>
                </Column>
                <Column>
                  <template #body="slotProps">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2" aria-label="Eliminar"
                      @click="eliminarJerarquia(slotProps.data.Id_empleado_jerarquia)" />
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </TabPanel>


      </TabView>
      <template #footer>
        <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="cancelarDialogoDetalles" />
      </template>
    </Dialog>
    <template>
      <div>
        <Dialog :style="{ width: '600px' }" :visible="showJerarquia" :modal="true" :closable="false" class="p-fluid">
          <template #header>
            <h3>ASIGNAR JERARQUIA</h3>
          </template>


          <div class="p-formgrid grid">
            <div class="p-field col-12">
              <label for="jerarquia">{{ labelJerarquia }}</label>
              <MultiSelect id="jerarquia" v-model="empleadoSeleccionado" :options="lstEmpleadosFiltrados"
                optionLabel="NombreCompleto" placeholder="Seleccione un empleado" display="chip" :filter="true" />
            </div>
            <div class="p-field col-12"
              v-if="objEmpleado.Categoria === 'CONFIANZA' || objEmpleado.Categoria === 'COORDINADOR DE SOPORTE TECNICO'">
              <label for="trabajaDirecto">Trabaja Directo</label>
              <Dropdown id="trabajaDirecto" v-model="trabajaDirectoSeleccionado" :options="trabajaDirecto"
                optionLabel="label" optionValue="value" placeholder="Seleccione si trabaja directo" />
            </div>
          </div>
          <template #footer>
            <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="cancelarDialogoUnidades" />
            <Button label="Confirmar" icon="pi pi-check" class="p-button-text" @click="confirmarJerarquia" />
          </template>
        </Dialog>
      </div>
    </template>


    <template>
      <div>
        <Dialog :style="{ width: '550px' }" :visible="showUnidades" :modal="true" :closable="false" class="p-fluid">
          <template #header>
            <h3>ASIGNAR UNIDAD</h3>
          </template>
          <div class="contenedor">
            <div class="p-field">
              <label for="unidadDropdown">Seleccione una unidad</label>
              <MultiSelect id="unidadDropdown" v-model="unidadSeleccionada" :options="lstUnidades" optionLabel="Unidad"
                placeholder="Seleccione una unidad" display="chip" class="w-full md:w-25rem" :filter="true" />
            </div>
          </div>
          <template #footer>
            <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="cancelarDialogoUnidades" />
            <Button label="Confirmar" icon="pi pi-check" class="p-button-text" @click="confirmarUnidades" />
          </template>
        </Dialog>
      </div>
    </template>


    <Dialog :style="{ width: '550px', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }" :visible="showAgregar" :modal="true" class="p-fluid" :closable="true" :draggable="false" :dismissableMask="false">

      
      <template #header>
        <div v-if="showAgregar" class="p-fluid fixed-container"></div>
        
        <h3>{{ modoEdicion }} Empleado</h3>
      </template>
      <div class="p-formgrid grid">
    <!-- Contenedor de la primera columna con imagen y espacio para campos -->
    <div class="p-field col-6" style="display: flex; flex-direction: column; align-items:center">
      <!-- Primera fila: Imagen -->
      <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
        <img :src="getImageUrl(objEmpleado.Matricula)" alt="Foto de empleado" v-if="objEmpleado.Matricula"
             style="max-width: 45%; height: auto; display: block;" />
      </div>
      
      <!-- Segunda fila: Espacio vacío para mantener la estructura -->
      <div style="flex: 1;"></div>
    </div>

    <!-- Columna derecha con Matrícula y Nombres -->
    <div class="p-field col-6">
      <!-- Matrícula -->
      <div>
        <label for="matricula">Matrícula</label>
        <InputText autocomplete="off" id="matricula" v-model.trim="objEmpleado.Matricula" required="true" autofocus
          :class="{ 'p-invalid': submitted && !objEmpleado.Matricula }" :disabled="isEditing" />
        <small class="p-invalid" v-if="submitted && !objEmpleado.Matricula">La matrícula es requerida.</small>
      </div>

      <!-- Nombres -->
      <div>
        <label for="nombres">Nombres</label>
        <InputText autocomplete="off" id="nombres" v-model.trim="objEmpleado.Nombres" required="true" autofocus
          :class="{ 'p-invalid': submitted && !objEmpleado.Nombres }" />
        <small class="p-invalid" v-if="submitted && !objEmpleado.Nombres">Los nombres son requeridos.</small>
      </div>
    </div>
  </div>

  <div class="p-formgrid grid">
    <!-- Apellido Paterno y Materno en columnas separadas -->
    <div class="p-field col-6">
      <label for="ap_pat">Apellido Paterno</label>
      <InputText autocomplete="off" id="ap_pat" v-model.trim="objEmpleado.Ap_pat" required="true" autofocus
        :class="{ 'p-invalid': submitted && !objEmpleado.Ap_pat }" />
      <small class="p-invalid" v-if="submitted && !objEmpleado.Ap_pat">El apellido paterno es requerido.</small>
    </div>

    <div class="p-field col-6">
      <label for="ap_mat">Apellido Materno</label>
      <InputText autocomplete="off" id="ap_mat" v-model.trim="objEmpleado.Ap_mat" required="true" autofocus />
    </div>
        <div class="p-field col-12">
          <label for="ap_mat">Nombre remedy</label>
          <InputText autocomplete="off" id="nombre_remedy" v-model.trim="objEmpleado.Nombre_remedy" required="true" autofocus />
        </div>
        <div class="p-field col-6">
          <label for="Correo_inst">Correo institucional</label>
          <InputText autocomplete="off" id="correo_inst" v-model.trim="objEmpleado.Correo_inst" required="true" autofocus 
          :class="{'p-invalid': submitted && !objEmpleado.Correo_inst}" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Correo_inst">El correo institucional es requerido.</small>
        </div>
        <div class="p-field col-6">
          <label for="Telefono">Teléfono</label>
          <InputText autocomplete="off" id="Telefono" v-model.trim="objEmpleado.Telefono" required="true" autofocus
          :class="{'p-invalid': submitted && !objEmpleado.Telefono}" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Telefono">El Teléfono es requerido.</small>
        </div>
        <div class="p-field col-6">
          <label for="Turno">Turno</label>
          <Dropdown id="turno" v-model="objEmpleado.Turno" :options="turno" placeholder="Seleccione un turno" 
          :class="{'p-invalid': submitted && !objEmpleado.Turno}"/>
          <small class="p-invalid" v-if="submitted && !objEmpleado.Turno">El turno es requerido.</small>
        </div>
        <div class="p-field col-6">
          <label for="Horario">Horario</label>
          <InputText autocomplete="off" id="horario" v-model.trim="objEmpleado.Horario" required="true" autofocus 
          :class="{'p-invalid': submitted && !objEmpleado.Horario}" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Horario">El Horario es requerido.</small>
        </div>
        <div class="p-field col-6">
          <label for="Dias_descanso">Dias de descanso</label>
          <MultiSelect id="Dias_descanso" v-model="DiasSeleccionados" :options="dias" optionLabel="Label"
          optionValue="dia" display="chip" placeholder="Seleccione dias de descanso" :MaxSelected="2"
          :class="{'p-invalid': submitted && !objEmpleado.Dias_descanso}" @change="DiasSeleccionadosMax" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Dias_descanso">Los dias de descanso son requeridos.</small>
        </div>
        <div class="p-field col-6">
          <label for="Tipo_contratacion">Tipo de contratación</label>
          <Dropdown id="Tipo_contratacion" v-model="objEmpleado.Tipo_contratacion" :options="contratacion"
          placeholder="Seleccione tipo de contratacion"
          :class="{ 'p-invalid': submitted && !objEmpleado.Tipo_contratacion}" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Tipo_contratacion">El tipo de contratacion es requerido.</small>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Id_estatus">Estatus</label>
          <Dropdown id="Id_estatus" v-model="objEmpleado.Id_estatus" :options="status" optionLabel="Label"
            optionValue="Id" placeholder="Selecciona un Estatus" />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Categoria">Categoría</label>
          <Dropdown id="Categoria" v-model="objEmpleado.Categoria" :options="categoria"
            placeholder="Seleccione una Categoría" class="w-full"
            :class="{ 'p-invalid': submitted && !objEmpleado.Categoria }" @change="objEmpleado.Categoria !== 'CONFIANZA'" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Categoria">La categoría es requerida</small>
        </div>
        <div class="p-field col" v-if="isPuestoEnabled">
          <label for="puesto">Puesto</label>
          <InputText autocomplete="off" id="puesto" v-model.trim="objEmpleado.Puesto" required="true" autofocus
            :class="{ 'p-invalid': submitted && !objEmpleado.Puesto }" />
          <small class="p-invalid" v-if="submitted && !objEmpleado.Puesto">El puesto es requerido.</small>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Fecha_nacimiento">Fecha de nacimiento</label>
    <Calendar 
      id="Fecha_nacimiento" 
      v-model="objEmpleado.Fecha_nacimiento" 
      dateFormat="yy-mm-dd" 
      showIcon 
      :yearNavigator="true" 
      :monthNavigator="true" 
      yearRange="1900:2024" 
      :class="{'p-invalid': submitted && !objEmpleado.Fecha_nacimiento}" 
    />
    <small class="p-invalid" v-if="submitted && !objEmpleado.Fecha_nacimiento">
      La fecha de nacimiento es requerida.
    </small>
        </div>
      </div>
      <template #footer>
        <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelarDialogo" />
        <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="guardarEmpleado" />
      </template>
    </Dialog>
    <Dialog :style="{ width: '95vw',height: '90vh' }" :visible="displayChart" class="p-fluid" :maximizable="true" :modal="true" @hide="cancelDialogChart" :pt="{closeButton : { onClick : cancelDialogChart}}">
      <template #header>
        <h3>Asignaciones</h3>
      </template>
        <div :style="{ height: '90vh' }">
          <JerarquiaComponent :empleadoSeleccionado = "selectedEmpleado" :empleadosSeleccionados="lstEmpleados"></JerarquiaComponent>
        </div>
    </Dialog>
  </div>
  <ConfirmDialog></ConfirmDialog>
  <Toast />
</template>

<script>
import Srvr from "../service/Empleados";
import { FilterMatchMode } from 'primevue/api'; 
import { mapGetters } from 'vuex'
import Utilerias from "../utilidades/Utilerias";
import Unidades from "../service/Unidades";
import Empleados from "../service/Empleados";
import JerarquiaComponent from "./JerarquiaComponent.vue";

export default {
  components: {
    JerarquiaComponent
  },
  data() {
    return {
      filters: {
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      lstEmpleados: [],
      loading: false,
      nombre: '',
      isEditing: false,
      submitted: false,
      showAgregar: false,
      showDetalles: false,
      showUnidades: false,
      showJerarquia: false,
      modoEdicion: '',
      unidades: [],
      lstEmpleadosFiltrados: [],
      lstUnidades: [],
      DiasSeleccionados: [],
      jerarquia: [],
      lstJerarquia: [],
      objUnidad: {
        Matricula: '',
        Id_unidad: '',
        Amibas: '',
      },
      objEmpleado: {},
      status: [
        { Id: 10, Label: "Activo" },
        { Id: 11, Label: "Inactivo" },
      ],
      unidadSeleccionada: [],
      empleadoSeleccionado: null,
      trabajaDirectoSeleccionado: true,
      contratacion: [
        "BASE", "SUPLENTE", "CONFIANZA"
      ],
      turno: [
        "MATUTINO", "VESPERTINO"
      ],
      categoria: [
        "AUXILIAR DE SOPORTE TECNICO", "OFICIAL DE SOPORTE TECNICO", "COORDINADOR DE SOPORTE TECNICO", "CONFIANZA"
      ],
      trabajaDirecto: [
        { label: "Si", value: true },
        { label: "No", value: false },
      ],
      dias: [
        { dia: '1', Label: "Domingo"},
        { dia: '2', Label: "Lunes"},
        { dia: '3', Label: "Martes"},
        { dia: '4', Label: "Miércoles"},
        { dia: '5', Label: "Jueves"},
        { dia: '6', Label: "Viernes"},
        { dia: '7', Label: "Sábado"},
      ],
      displayChart: false,
      selectedEmpleado: null,
    };
  },
  created() {
  },
  mounted() {
    this.Carga

this.CargaInicial();
},
methods: {
  getImageUrl(matricula) {
      if (matricula) {
        return `http://172.23.137.15/webaps/recursos/imagen/original/${matricula}.jpg`;
      }
      return '';
    },
  formateaFechaAMD(fecha) {
    var utils = new Utilerias();
    return utils.formateaFechaAMD(fecha);
  },
  convertirFechaAEpoch(fecha) {
    var utils = new Utilerias();
    return utils.convertirFechaAEpoch(fecha);
  },
  formateaFechaDDMMYY(fecha) {
    if (!fecha) return ''; // Manejar caso de fecha nula
    const partes = fecha.split('-'); // Separar por el guion
    return `${partes[2]}/${partes[1]}/${partes[0]}`; // Formato DD/MM/YYYY
  },
  getDiasLabels(diasConcatenados){
    if(!diasConcatenados) return '';
    var diasArray = diasConcatenados.split('-');
    var labels = diasArray.map(diaId => {
      var diaObj = this.dias.find(d => d.dia === diaId.trim());
      return diaObj ? diaObj.Label : '';
    });
    return labels.join('-');
  },
  DiasSeleccionadosMax(){
    if(this.DiasSeleccionados.length > 2){
      this.errroDiasSeleccionados = 'Solo puede seleccionar 2 días de descanso como máximo.';
      this.DiasSeleccionados = this.DiasSeleccionados.slice(0,2);
    }else{
      this.errroDiasSeleccionados = '';
    }
  },
  getStatusClass(idestatus) {
    return idestatus === 10 ? 'status-activo' : 'status-inactivo';
  },
  getLabelStatus(Id) {
    var statusObj = this.status.find(status => status.Id === Id);
    return statusObj ? statusObj.Label : "Desconocido";
  },
  getTrabaja(value) {
    var objTrabaja = this.trabajaDirecto.find(trabajaDirecto => trabajaDirecto.value === value);
    return objTrabaja ? objTrabaja.label : '';
  },
  reiniciaEmpleado() {
    this.objEmpleado = {};
    this.DiasSeleccionados= null;
  },
  CargaInicial() {
    this.loading = true;
    var ctlSrv = new Srvr();
    ctlSrv.getEmpleados(this).then((res) => {
        const utilerias = new Utilerias();
        this.lstEmpleados = res.map(empleado => {
            // Usa getFechaWCFDate para obtener un objeto Date
            const fechaNacimiento = utilerias.getFechaWCFDate(empleado.Fecha_nacimiento);

            // Función para formatear la fecha en YYYY-MM-DD
            const formatFechaYMD = (fecha) => {
                if (fecha) {
                    const anio = fecha.getFullYear();
                    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
                    const dia = fecha.getDate().toString().padStart(2, '0');
                    return `${anio}-${mes}-${dia}`;
                }
                return ""; // Retorna una cadena vacía si la fecha es nula
            };

            return {
                ...empleado,
                Fecha_nacimiento: formatFechaYMD(fechaNacimiento)
            };
        });
        this.loading = false;
    }).catch(error => {
        console.error('Error en CargaInicial:', error);
        this.loading = false;
    });
}
,
  agregarEmpleado() {
    this.reiniciaEmpleado();
    this.modoEdicion = "Agregar";
    this.objEmpleado.Id_estatus = 10;
    this.isEditing = false;
    this.showAgregar = true;
  },
  editarEmpleado(data) {
  this.modoEdicion = "Editar";
  this.isEditing = true;
  
  // Copiamos los datos del empleado al objeto de edición
  this.objEmpleado = { ...data };

  // Convertir la fecha de nacimiento al formato dd/mm/yy si existe
  if (this.objEmpleado.Fecha_nacimiento) {
    const fecha = new Date(this.objEmpleado.Fecha_nacimiento);
    const dia = fecha.getUTCDate().toString().padStart(2, '0');
    const mes = (fecha.getUTCMonth() + 1).toString().padStart(2, '0'); // Los meses son base 0
    const anio = fecha.getUTCFullYear().toString().slice(-2); // Tomar solo los últimos dos dígitos del año
    this.objEmpleado.Fecha_nacimiento = `${dia}/${mes}/${anio}`;
  }

  // Convertir los días de descanso a un array
  this.DiasSeleccionados = this.objEmpleado.Dias_descanso ? this.objEmpleado.Dias_descanso.split('-') : [];

  // Mostrar el modal o sección para agregar/editar
  this.showAgregar = true;
}
,
  guardarEmpleado() {
    this.submitted = true;

    // Validación de campos requeridos
    if (!this.objEmpleado.Matricula || !this.objEmpleado.Nombres || !this.objEmpleado.Ap_pat || (this.isPuestoEnabled && !this.objEmpleado.Puesto)
        || !this.objEmpleado.Categoria || !this.objEmpleado.Turno || !this.objEmpleado.Tipo_contratacion || !this.objEmpleado.Telefono) {
        this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Todos los campos son obligatorios.",
            life: 3000
        });
        return;
    }

    // Validación específica para los días de descanso
    if (!this.DiasSeleccionados || this.DiasSeleccionados.length === 0) {
        this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Los días de descanso son requeridos.",
            life: 3000
        });
        return;
    }

    // Asignar el puesto si la categoría lo requiere
    if (['COORDINADOR DE SOPORTE TECNICO', 'OFICIAL DE SOPORTE TECNICO', 'AUXILIAR DE SOPORTE TECNICO'].includes(this.objEmpleado.Categoria)) {
        this.objEmpleado.Puesto = this.objEmpleado.Categoria;
    }

    var ctlSrv = new Srvr();

    // Modo Agregar
    if (this.modoEdicion === "Agregar") {
        var empleadoExistente = this.lstEmpleados.some(mat => mat.Matricula === this.objEmpleado.Matricula);
        if (empleadoExistente) {
            this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "La matricula ya existe",
                life: 3000
            });
            return;
        }

        var empleadoNuevo = {
          ...this.objEmpleado,
          Fecha_nacimiento: this.objEmpleado.Fecha_nacimiento ? new Utilerias().formateaFechaDATE(this.objEmpleado.Fecha_nacimiento) : null,
          Id_usuario_registro: this.getUsuarioLogueado.Usuario.Id_usuario,
          Dias_descanso: this.DiasSeleccionados.join('-')
        };

        ctlSrv.addEmpleado(this, empleadoNuevo).then(() => {
            this.CargaInicial();
            this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: "Empleado agregado correctamente",
                life: 3000
            });
        }).catch(() => {
            this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error al agregar al empleado",
                life: 3000
            });
        });

    // Modo Editar
    } else if (this.modoEdicion === "Editar") {
        var EmpleadoActualizado = {
            ...this.objEmpleado,
            Fecha_nacimiento: this.objEmpleado.Fecha_nacimiento ? new Utilerias().formateaFechaDATE(this.objEmpleado.Fecha_nacimiento) : null,
            Id_usuario_mod: this.getUsuarioLogueado.Usuario.Id_usuario,
            Dias_descanso: this.DiasSeleccionados.join('-')
        };

        ctlSrv.updateEmpleados(this, EmpleadoActualizado).then(() => {
            this.CargaInicial();
            this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: "Empleado editado correctamente",
                life: 3000
            });
        }).catch(() => {
            this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error al actualizar al empleado",
                life: 3000
            });
        });
    }

    this.submitted = false;
    this.showAgregar = false;
    this.reiniciaEmpleado();
    this.DiasSeleccionados = null;
},


  dialogDetalles(data) {
    var matricula = data.Matricula;
    var categoria = data.Categoria;
    this.NombreCompleto = data.NombreCompleto;
    this.objEmpleado.Matricula = matricula;
    this.objEmpleado.Categoria = categoria;
    this.objEmpleado.NombreCompleto = this.NombreCompleto;
    this.showDetalles = true;
    var ctlSrv = new Srvr();
    ctlSrv.getxMatricula(this, matricula).then((res) => {
      this.unidades = res;
    })
  },
  cancelarDialogo() {
    this.submitted = false
    this.showAgregar = false;
    this.modoEdicion = "";
    this.reiniciaEmpleado();
  },
  cancelarDialogoDetalles() {
    this.submitted = false;
    this.showDetalles = false;
  },
  asignarUnidades() {
    var ctlSrv = new Unidades();
    ctlSrv.getAll(this).then((res) => {
      this.lstUnidades = res;
    })
    this.showUnidades = true;
  },
  asignarJerarquia() {
    var ctlSrv = new Empleados();
    ctlSrv.getJerarquia(this.objEmpleado.Matricula).then((res) => {
      this.jerarquia = res;
    });
    this.showJerarquia = true;
  },
  cancelDialogChart(){
    this.displayChart = false;
  },
  dialogChart(data){
    this.selectedEmpleado = {...data};
    this.displayChart = true;
  }
},
computed: {
  ...mapGetters(["getUsuarioLogueado"]),
},
};
</script>



<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}


.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}


.product-image {
  width: 100px;
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
}


.unidad-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-bottom: 10px;
  width: 70%;
}


.nombre-unidad {
  font-weight: bold;
}


.titulo-unidad {
  font-weight: bold;
  text-transform: uppercase;
}


.contenedor {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px 0;
}
</style>


